import React from 'react';
import AdminProductList from '../../components/Admin/AdminProductList/AdminProductList';

export default function AdminProducts() {
    return (
        <div className="admin-product-list-container">
            <AdminProductList/>
        </div>
    );
}